import type { IconSvgObject } from './types';

const ChevronsDownUpIcon: IconSvgObject = [
  ["path", { d: "M7 5L12 10L17 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 19L12 14L17 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsDownUpIcon;
